/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class FileExplorerCountSecurityAlertsInResourceResponse {
  /**
  * The number of security alerts in the resource
  */
  'count': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "count",
      "baseName": "count",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return FileExplorerCountSecurityAlertsInResourceResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

